var env = require("../utils/env");
var apiDomain = env.domain.api;
var Auth = require("./auth");
var request = require('superagent');
var async = require('async');

var exports = module.exports = {};

exports.collectionsMap = {};

exports.retrieveSingleCollection = function(options, callback) {
    callback = callback || function() {};
    if (!options.collectionId) return callback('NO COLLECTION ID');
    request.get(apiDomain + '/v1/kquizzes/' + options.collectionId)
        .query(options.query)
        .withCredentials()
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            return callback(err.response.body);
        })
}

exports.retrieveCollectionQuestionStat = function(collection, callback) {
    callback = callback || function() {};
    request
        .get(apiDomain + "/v1/kquizzes/" + collection._id + "/kquestions/type_stats")
        .withCredentials()
        .then(function(response) {
            collection.questionStat = response.body;
            return callback(null, collection);
        }, function(err) {
            return callback(err);
        })
}

exports.retrieveCollections = function(options, callback) {
    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};
    // if (currentUser.role === 'admin') {
    //
    // } else {
    //   options.conditions.creator = currentUser._id;
    // }
    if (currentUser.role !== 'admin' && !options.conditions.creator) {
        options.conditions.creator = currentUser._id;
    }

    console.log(options);
    request
        .get(apiDomain + '/v1/kquizzes')
        .query({
            sort: options.sort,
            limit: options.limit,
            skip: options.skip,
            conditions: JSON.stringify(options.conditions),
            include: options.include,
            conditions1: JSON.stringify(options.includeConditions),
            conditions2: JSON.stringify(options.conditions2) //for school question bank
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}

exports.deleteCollection = function(collection, callback) {
    callback = callback || function() {};
    if (!collection || !collection._id) return callback('INVALID COLLECTION');
    request
        .delete(apiDomain + '/v1/kquizzes/' + collection._id)
        .withCredentials()
        .then(function(response) {
            return callback(null, response);
        }, function(err) {
            return callback(err);
        })
}

exports.saveCollection = function(collection, callback) {
    callback = callback || function() {};
    var tmpCollection = JSON.parse(JSON.stringify(collection));
    delete tmpCollection.questions;
    if (collection._id) {
        request
            .put(apiDomain + '/v1/kquizzes/' + collection._id)
            .withCredentials()
            .send(tmpCollection)
            .then(function(response) {
                var newCollection = Object.assign(collection, response.body);
                saveQuestion(newCollection, function(err1, resArr) {
                    newCollection.questions = resArr;
                    return callback(err1, newCollection);
                })
            }, function(err) {
                return callback(err);
            })
    } else {
        request
            .post(apiDomain + '/v1/kquizzes')
            .withCredentials()
            .send(tmpCollection)
            .then(function(response) {
                var newCollection = Object.assign(collection, response.body);
                saveQuestion(newCollection, function(err1, resArr) {
                    newCollection.questions = resArr;
                    return callback(err1, newCollection);
                });
            }, function(err) {
                return callback(err);
            })
    }
}

var saveQuestion = function(collection, cb) {
    var kQuestions = [];
    var callbackArr = [];
    console.log(collection)
    for (var i = 0; i < collection.questions.length; i++) {
        kQuestions.push(collection.questions[i].kquestion);
        console.log(kQuestions)
        createQuestionsTask(callbackArr, kQuestions[i], i, collection);
    }

    async.series(callbackArr, function(err, resArr) {
        if (cb) return cb(err, resArr);
    })
}
exports.DeleteQuestion = function(collectionId, questionId, callback) {
    callback = callback || function() {};
    request
        .delete(apiDomain + '/v1/kquizzes/' + collectionId + '/kquestions/' + questionId)
        .withCredentials()
        .then(function(res) {
            return callback(null, res.body);
        }, function(err) {
            return callback(err);
        })
}
exports.UpdateKQuestion = function(collectionId, question, callback) {
    callback = callback || function() {};
    request
        .put(apiDomain + '/v1/kquizzes/' + collectionId + '/contentkquestions/' + question.questionRef)
        .withCredentials()
        .send(question)
        .then(function(res) {
            return callback(null, res.body);
        }, function(err) {
            return callback(err);
        })
}


var createQuestionsTask = function(callbackArr, question, questionIndex, collection) {
    // if modified old question -> update it
    if (question._id) {
        callbackArr.push(function(callback) {
            request
                .put(apiDomain + '/v1/kquizzes/' + collection._id + '/kquestions/' + question._id)
                .withCredentials()
                .send(question)
                .then(function(res) {
                    callback(null, res.body);
                }, function(err) {
                    callback(err);
                })
        });
    }
    // if modified new question -> create and save it
    else {
        callbackArr.push(function(callback) {
            request
                .post(apiDomain + '/v1/kquizzes/' + collection._id + '/kquestions')
                .withCredentials()
                .send(question)
                .then(function(res) {
                    callback(null, res.body)
                }, function(err) {
                    callback(err);
                })
        });
    }
}

exports.updateCollectionOnly = function(newCollection, callback) {
    callback = callback || function() {};
    var tmpCollection = JSON.parse(JSON.stringify(newCollection));
    delete tmpCollection.questions;
    request
        .put(apiDomain + '/v1/kquizzes/' + newCollection._id)
        .withCredentials()
        .send(tmpCollection)
        .then(function(res) {
            return callback(null, res.body);
        }, function(err) {
            return callback(err);
        })
}

exports.updateAllKquestionInCollection = function(options, callback) {
    callback = callback || function() {};
    request
        .put(apiDomain + "/v1/kquizzes/" + options.collectionId + "/kquestions")
        .send(options.body)
        .withCredentials()
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            return callback(err);
        })
}

exports.countCollection = function(options, callback) {
    callback = callback || function() {};
    request
        .get(apiDomain + "/v1/kquizzes/count")
        .query({
            conditions: JSON.stringify(options.conditions),
            conditions2: JSON.stringify(options.conditions2)
        })
        .withCredentials()
        .then(function(response) {
            return callback(null, response.body)
        }, function(err) {
            return callback(err);
        })
}



/** WEBPACK FOOTER **
 ** ./src/resources/collection.js
 **/